<template>
<transition name="zoom">
  <div class="search">
    <div class="search_bar">
      <van-icon name="search" size="1.3rem" />
      <van-field v-model="keyword"  placeholder="输入搜索关键字"   @focus="getSearchList"
            @input="getSearchList"  />
      <span v-if="keyword!==''" @click="searchByKeyWord('')">搜索</span>
      <span v-else @click="$router.back()">取消</span>
    </div>   
    <div class="history">
      <div class="title">
        <div style="color: rgb(180, 180, 180);">历史记录</div>
        <van-icon name="delete"  @click.native="deleteHistory" />
      </div>
      <div class="content">
        <div v-for="(item,index) in historyData" :key="index" class="h_item" @click="searchByKeyWord(item)">
          {{item}}
        </div>
      </div>
    </div> 
    <div class="history">
      <div class="title" >
        <div style="color: rgb(180, 180, 180);">大家都在搜</div>
        <van-icon name="replay" @click.native="changeSearch"  />
      </div>
      <transition name="LeftIn">
      <div class="content">
        <div v-for="(item,index) in publicSearchData" :key="index" class="h_item" @click="searchByKeyWord(item)">
          {{item}}
        </div>
      </div>
      </transition>
    </div>
    <van-popup v-model="pop" v-if="keyword!==''" position="top" :style="{ height: '100vh',width:'100vw',top:'5rem' }" duration="0.2"  :overlay="false">
      <div class="search_key_list" v-for="item in suggestWordList" :key="item">
        <div @click="searchByKeyWord(item)" class="div">{{item}}</div>
        <div class="arrow">↑</div>
      </div>

    </van-popup>
  </div>
</transition>
</template>

<script>
import { searchHistory,searchPublic,clearHistory,suggestWord } from '@/api/tb'
import { Form } from 'vant'
export default {
  name:'search',
  data(){
    return{
      keyword:'',
      historyData:[],
      publicSearchData:[],
      pop:false,
      keyword:'',
      actionText:'搜索',
      suggestWordList:[]
    }
  },
  activated(){
    var form = new FormData();
    form.append("userId",this.$store.state.userId); 
    searchHistory(form).then(res=>{
      this.historyData = res.data
    })
    searchPublic({userId:this.$store.state.userId}).then(res=>{
      this.publicSearchData = res.data
    })
  },
  deactivated(){
    this.keyword = ''
    
  },
  methods:{
    getSearchList(){
      this.pop = true
      var form = new FormData();
      form.append("content",this.keyword);
      suggestWord(form).then(res=>{
        this.suggestWordList = res.data
      })
    },
    searchByKeyWord(key){
      if(key!==''&&typeof(key)!=='object'){
        this.keyword = key
      }
      this.pop = false
      this.$router.push('/category?key='+this.keyword)
    },
    changeSearch(){
      searchPublic({userId:this.$store.state.userId}).then(res=>{
        this.publicSearchData = res.data
      })      
    },
    deleteHistory(){
      var form = new FormData();
      form.append("userId",this.$store.state.userId);

      clearHistory(form).then(res=>{
        searchHistory(form).then(res=>{
          this.historyData = res.data
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
/* zoom */
.zoom-enter-active{
  opacity: 1;
  transition: all .32s ease;  
}
.zoom-enter
 {
  transform: translateX(30%);
}
.LeftIn-enter
 {
  opacity: 0;
  // transform: translateX(30%);
}
.LeftIn-enter-active{
  opacity: 1;
  transition: all .32s ease;   
}
/deep/ .van-cell{
  padding-left: 1rem;
  padding-right: .4rem;
  width: 89vw;
  height: 5rem;
  &::after{
    border: 0;
  }
}
/deep/ .van-field__body{
  background-color: rgb(240, 240, 240);
  border-radius: 10px;
  margin-left: 0px;
  width: 84vw;
  height: 3rem;
    input{
      padding : 0 0 0 3rem;
      width: 80vw;
      height: 3rem;
    }
}
.search_key_list{
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 1rem;
  width: 100vw;
  font-size: 1.4rem;
  color: rgb(145, 145, 145);
  border-bottom: 1px rgba(100, 100, 100, 0.1) solid;
  span{
    color: rgba(40,40,40,0.9);
  }
  .arrow{
    font-weight: 600;
    font-size: 1.6rem;
    transform: rotate(-45deg);
  }
  .div{
    width: 86vw;
  }
}
.search{
  background-color: #fff;
  height: 100vh;
  padding-top: .4rem;
  .search_bar{
    display: flex;
    align-items: center;
    white-space: nowrap;
    font-size: 1.4rem;
    position: relative;
    i{
      position:absolute;
      z-index: 99;
      top: 1.7rem;
      left: 2rem;
      color: rgba(200,200,200,1);
    }
  }
}
.history{
  width: 100vw;
  padding: 1rem 1.6rem;
  box-sizing: border-box;
  font-size: 1.6rem;
  
  .title{
    
    display: flex;
    justify-content: space-between;
    margin-bottom: 1rem;
    font-size: 1.4rem;
    div{
      display: flex;
      align-items: center;
    }
    
  }
  .content{
    display: flex;
    flex-wrap: wrap;


    overflow: hidden;
    text-overflow:ellipsis;
  }
  .h_item{
    border-radius: 12px;
    background-color: rgb(250,250,250);
    padding: .5rem 1rem;
    // word-wrap:break-word;
    // word-break: break-all; 
    white-space: nowrap;
    height: 15px;
    line-height: 15px;
    color: rgb(85,85,85);
    font-size: 1.3rem;
    margin-left: 1.2rem;
    margin-bottom: .7rem;
    
  }
}
</style>